document.addEventListener('DOMContentLoaded', () => {
    const collapsibleButtons = document.querySelectorAll('[data-collapsible-button]');
    collapsibleButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const dataAttribute = button.getAttribute('data-collapsible-button');
            const collapsibleWrapper = document.querySelector(`[data-collapsible-wrapper="${dataAttribute}"]`);
            const collapsibleContent = document.querySelector(`[data-collapsible-content="${dataAttribute}"]`);
            if (button.classList.toggle('opened')) {
                collapsibleWrapper.style.maxHeight = collapsibleContent.offsetHeight + 'px';
            }
            else {
                collapsibleWrapper.style.maxHeight = '0px';
            }
        });
    })

});